import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CopyButton from '../common/CopyButton';

const TransactionDetailsListItem = ({ label, value, copyText }) => {
    return (
        <div className="self-stretch !p-4 bg-[#F4F4F5] dark:bg-[#FFFFFF14] rounded-md inline-flex flex-col justify-start items-start gap-1 overflow-hidden w-full">
            <div className="self-stretch inline-flex justify-start items-center gap-1">
                <div className="flex-1 inline-flex flex-col justify-center items-start gap-1">
                    <div className="self-stretch text-balanceCard-manage text-xs font-medium uppercase">
                        {label}
                    </div>
                    <div className="!text-text text-sm font-semibold text-wrap">{value}</div>
                </div>
                {copyText && <CopyButton type="button" copyValue={copyText} />}
            </div>
        </div>
    );
};

TransactionDetailsListItem.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
    copyText: PropTypes.string,
};
export default TransactionDetailsListItem;
